import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { nanoid } from "@reduxjs/toolkit";
import { getFullUrlPath } from "./HandleFileFunction";
import { getSupplierProductName } from "./HelperProduct";
import moment from "moment";
export function mappingLotGrs(receivelist) {
    if (receivelist && receivelist.length > 0) {
        return receivelist.map(function(receive) {
            return {
                lot_number: receive.number,
                receive_quantity: receive.receiveQty,
                date_expired: receive.dateExpire
            };
        });
    }
    return null;
}
export function mappingLotReceives(grList) {
    if (grList && grList.length > 0) {
        return grList.map(function(receive) {
            return {
                number: receive.lot_number,
                receiveQty: receive.receive_quantity,
                dateExpire: receive.date_expired,
                isReadOnly: true
            };
        });
    }
    return [];
}
export function mappingGr(param) {
    var grData = param.grData, action = param.action, setPdata = param.setPdata, setProductRow = param.setProductRow, setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setAttachments = param.setAttachments, setTagSelected = param.setTagSelected;
    var _dataWithReplacements_dimWarehouse, _dataWithReplacements_dimMstFinancialStatus, _dataWithReplacements_dimMstFinancialStatus1;
    var dataWithReplacements = Object.entries(grData).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = value === null ? "" : value;
        return acc;
    }, {});
    if (dataWithReplacements.dimSupplierInformation) {
        var dimSupplierInformation = dataWithReplacements.dimSupplierInformation;
        var full_supplier_name = dataWithReplacements.full_supplier_name, full_supplier_address_name = dataWithReplacements.full_supplier_address_name;
        setPdata(function(prev) {
            return {
                id: dimSupplierInformation.id,
                dimGroupOfSupplierCode: dimSupplierInformation.dimGroupOfSupplier ? dimSupplierInformation.dimGroupOfSupplier.code : "-",
                full_supplier_name: full_supplier_name,
                initials: dimSupplierInformation.initials,
                company_branch_code: dimSupplierInformation.company_branch_code,
                company_branch_name: dimSupplierInformation.company_branch_name,
                full_supplier_address_name: full_supplier_address_name,
                company_phone_number: dimSupplierInformation.company_phone_number
            };
        });
        dataWithReplacements.supplier_phone_number = dimSupplierInformation.company_phone_number;
        var _dimSupplierInformation_initials;
        dataWithReplacements.supplier_nickname = (_dimSupplierInformation_initials = dimSupplierInformation.initials) !== null && _dimSupplierInformation_initials !== void 0 ? _dimSupplierInformation_initials : "-";
    }
    if (dataWithReplacements.dimDocFileGr && dataWithReplacements.dimDocFileGr.length > 0) {
        var attchments = dataWithReplacements.dimDocFileGr.map(function(v, i) {
            var newId = nanoid();
            var type = v.original_file_name.split(".");
            var mappingData = {
                id: newId,
                docId: v.id,
                docFile: v.original_file_name,
                docFileType: type[type.length - 1],
                docFileData: "",
                docUrl: getFullUrlPath(v.file_path)
            };
            return mappingData;
        });
        setAttachments(attchments);
    }
    if (dataWithReplacements.dimTagGr && dataWithReplacements.dimTagGr.length > 0) {
        var mappingData = dataWithReplacements.dimTagGr.map(function(v) {
            return v.name;
        });
        setTagSelected(mappingData);
    }
    if (dataWithReplacements.dimNewGrItem && dataWithReplacements.dimNewGrItem.length > 0) {
        var productItems = dataWithReplacements.dimNewGrItem.map(function(v) {
            var _dimProductPrice_dimProduct, _dimProductPrice_dimProduct1, _dimProductPrice_dimProduct2, _dimProductPrice_dimProduct3;
            var id = v.id, dim_product_price_id = v.dim_product_price_id, po_split_quantity = v.po_split_quantity, unit_price = v.unit_price, unit_id = v.unit_id, ratio_unit = v.ratio_unit, container = v.container, dim_mst_discount_type_id = v.dim_mst_discount_type_id, remark = v.remark, discount_value = v.discount_value, discount_price = v.discount_price, dimWarehouse = v.dimWarehouse, dimProductPrice = v.dimProductPrice, dimMasterUnit = v.dimMasterUnit, dimMstVat = v.dimMstVat, received_quantity = v.received_quantity, receive_quantity = v.receive_quantity, remaining_quantity = v.remaining_quantity, dimGrLot = v.dimGrLot;
            // console.log(discount_price);
            var mappingData = {
                rowID: nanoid(),
                productID: dim_product_price_id,
                dim_new_po_split_item_id: id,
                productCode: (_dimProductPrice_dimProduct = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct === void 0 ? void 0 : _dimProductPrice_dimProduct.sku,
                productName: (_dimProductPrice_dimProduct1 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct1 === void 0 ? void 0 : _dimProductPrice_dimProduct1.name_th,
                productBarcode: dimProductPrice.barcode,
                productUnitID: unit_id,
                productRatioUnit: ratio_unit,
                productContainer: container,
                supplierCode: (_dimProductPrice_dimProduct2 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct2 === void 0 ? void 0 : _dimProductPrice_dimProduct2.supplier_code,
                supplierName: getSupplierProductName((_dimProductPrice_dimProduct3 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct3 === void 0 ? void 0 : _dimProductPrice_dimProduct3.supplier_names),
                warehouseID: dimWarehouse.id,
                warehouseName: dimWarehouse.name,
                productUnit: dimMasterUnit ? dimMasterUnit.name : "-",
                productQty: po_split_quantity,
                productOrdered: "",
                productOrderQuantity: po_split_quantity,
                productReceivedQuantity: received_quantity,
                productReceiveQuantity: receive_quantity,
                receivelist: mappingLotReceives(dimGrLot),
                ums: "",
                productStock: "",
                productPrice: unit_price,
                discountType: dim_mst_discount_type_id,
                discount: discount_price,
                discountPercent: discount_value,
                tax: "",
                price_before_tax: 0,
                dim_mst_vat_id: dimMstVat.id,
                vat: dimMstVat.value,
                note: remark,
                price_after_tax: 0,
                not_approve_reason: "",
                is_checked: false,
                edit: false
            };
            return mappingData;
        });
        dataWithReplacements.products = productItems;
        setProductRow(productItems);
    }
    if (action !== "create") {
        setFormdisabled(true);
    }
    dataWithReplacements.dim_mst_new_status_id = "";
    dataWithReplacements.dim_new_item_pr_sorts = [];
    if (dataWithReplacements.dimNewItemPrSort && dataWithReplacements.dimNewItemPrSort.length > 0) {
        var mappingCols = dataWithReplacements.dimNewItemPrSort.map(function(v) {
            return {
                id: v.dimMstNewItemPrCol.id,
                sortKey: v.dimMstNewItemPrCol.name
            };
        });
        while(mappingCols.length <= 3){
            mappingCols.push({
                id: "",
                sortKey: ""
            });
        }
        setColumnsort(_object_spread_props(_object_spread({}, columnsort), {
            columnsort: mappingCols
        }));
    }
    dataWithReplacements.dim_warehouse_name = (_dataWithReplacements_dimWarehouse = dataWithReplacements.dimWarehouse) === null || _dataWithReplacements_dimWarehouse === void 0 ? void 0 : _dataWithReplacements_dimWarehouse.name;
    dataWithReplacements.financialStatusID = (_dataWithReplacements_dimMstFinancialStatus = dataWithReplacements.dimMstFinancialStatus) === null || _dataWithReplacements_dimMstFinancialStatus === void 0 ? void 0 : _dataWithReplacements_dimMstFinancialStatus.id;
    dataWithReplacements.financialStatusName = (_dataWithReplacements_dimMstFinancialStatus1 = dataWithReplacements.dimMstFinancialStatus) === null || _dataWithReplacements_dimMstFinancialStatus1 === void 0 ? void 0 : _dataWithReplacements_dimMstFinancialStatus1.name;
    return dataWithReplacements;
}
export function grVerifyCases(productReceive, sumProductBalanceQuantity) {
    var invalidCases = {
        qtyNotMatch: sumProductBalanceQuantity !== 0,
        inputInvalid: checkIsProductReceiveValid(productReceive)
    };
    return invalidCases;
}
export function isFinanVerify(param) {
    var dimMstFinancialStatus = param.dimMstFinancialStatus;
    var disabledList = [
        2,
        3,
        4
    ];
    if (dimMstFinancialStatus && disabledList.includes(parseInt(dimMstFinancialStatus.id))) {
        return true;
    }
    return false;
}
function checkIsProductReceiveValid(productRow) {
    if (!productRow) {
        return true;
    }
    return productRow.some(function(item) {
        if (item.productOrderQuantity === item.productReceivedQuantity) {
            return false;
        }
        if (!item.receivelist) {
            return true;
        }
        return receiveListhasEmptyFields(item.receivelist);
    });
}
function receiveListhasEmptyFields(receivelist) {
    return receivelist.some(function(receive) {
        return receive.number === "" || receive.dateExpire === "";
    });
}
export function checkDateDifference(inputDate) {
    if (!moment(inputDate, "YYYY-MM-DD", true).isValid()) {
        return "";
    }
    var currentDate = moment().format("YYYY-MM-DD");
    var givenDate = moment(inputDate, "YYYY-MM-DD");
    var diffDays = givenDate.diff(currentDate, "days");
    if (diffDays >= 30) {
        return "วันที่รับมากกว่า 30 วัน";
    } else if (diffDays <= -30) {
        return "วันที่รับน้อยกว่า 30 วัน";
    }
    return "";
}
